import { Component, Input } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { Product } from '@models/settings/billing/product.model';
import { Subscription } from '@models/settings/billing/subscription.model';

@Component({
    selector: 'app-module-selector-form',
    templateUrl: './module-selector.template.html',
})
export class ModuleSelectorForm extends BaseForm {
    @Input() products: Product[] = [];
    @Input() subscriptions: Subscription[] = [];

    selectedProductPlans: string[] = [];

    reset(): void {
        this.selectedProductPlans = [];
    }

    isProductSelected(product: Product): boolean {
        if (!product.defaultPlan) {
            return false;
        }
        return this.selectedProductPlans.includes(product.defaultPlan.identifier);
    }

    selectProduct(product: Product): void {
        this.selectedProductPlans = [...this.selectedProductPlans, product.defaultPlan.identifier];
    }

    unselectProduct(product: Product): void {
        this.selectedProductPlans = this.selectedProductPlans.filter((key) => key !== product.defaultPlan.identifier);
    }

    get selectedModuleCount(): number {
        if (!this.selectedProductPlans.length) {
            return null;
        }

        return this.selectedProductPlans.length;
    }

    get eligibleProducts(): Product[] | null {
        if (!this.products || !this.subscriptions) {
            return null;
        }
        const subscribedProducts = new Set();
        this.subscriptions.forEach((subscription) => {
            subscription.subscriptionItems.forEach((subscriptionItem) => {
                subscribedProducts.add(subscriptionItem.product);
            });
        });
        return this.products
            .filter(({ identifier }) => !subscribedProducts.has(identifier))
            .filter(({ isPublic }) => isPublic);
    }
}
